import { Modal } from "antd";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { IconClose } from "../images";
import "./style.scss";

const PopupHome = (props: any, ref: any) => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<any>(null);

  useImperativeHandle(ref, () => {
    return {
      handleVisibleModal,
    };
  });

  const handleVisibleModal = (bool: boolean, dataPopup: any = null) => {
    if (bool) {
      setData(dataPopup);
      setVisible(bool);
    } else {
      setVisible(bool);
    }
  };

  return (
    <Modal
      title={null}
      closeIcon={<img src={IconClose} />}
      // centered
      width={"calc(100vh - 60px)"}
      visible={visible}
      onOk={() => handleVisibleModal(false)}
      onCancel={() => handleVisibleModal(false)}
      footer={null}
      wrapClassName="popup-home-wrapper"
      className="popup-home">
      {data &&
        (data.url ? (
          <a href={data.url} target={data.target || "_self"}>
            <img
              src={
                (data.images.length &&
                  data.images[0].galaries.length &&
                  data.images[0].galaries[0].path) ||
                ""
              }
              alt=""
            />
          </a>
        ) : (
          <div>
            <img
              src={
                (data.images.length &&
                  data.images[0].galaries.length &&
                  data.images[0].galaries[0].path) ||
                ""
              }
              alt=""
            />
          </div>
        ))}
    </Modal>
  );
};

export default forwardRef(PopupHome);
